import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  makeSelectIsLoading,
  makeSelectNotification,
} from '../store/render-controller/render-controller.selectors';
import {
  INotification,
  TNotification,
  ENotification,
  noBackErrors,
} from '../domain/notification.interface';
import { clearNotification } from '../store/render-controller/render-controller.actions';
import { FormattedMessage } from 'react-intl';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import history from '../store/history/history';
import { ERoutes } from '../assets/constants/routes';
import { SpinnerComponent } from '../components/atoms/atoms.index';
import { EErrorName } from '../domain/notification.interface';

export function RenderController(props: any) {
  const dispatch = useDispatch();
  const isLoading: boolean = useSelector(makeSelectIsLoading());
  const notification: INotification = useSelector(makeSelectNotification());

  const modalStyleSelector = (type: TNotification) => {
    return type === ENotification.ERROR
      ? 'text-danger'
      : type === ENotification.WARNING
      ? 'text-warning'
      : 'text-success';
  };

  const modalIconSelector = (type: TNotification): IconProp => {
    return type === ENotification.ERROR
      ? 'exclamation'
      : type === ENotification.WARNING
      ? 'exclamation'
      : 'check';
  };

  if (isLoading) {
    return <SpinnerComponent />;
  }

  if (notification.msg1) {
    return (
      <div
        className='notificationModal modal'
        id='notificationModal'
        tabIndex={-1}
        role='dialog'
        aria-labelledby='notificationModalLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5
                className={`w-100 text-center ${modalStyleSelector(
                  notification.type,
                )}`}
              >
                <FontAwesomeIcon
                  icon={modalIconSelector(notification.type)}
                  size='2x'
                />
              </h5>
              {notification.type === ENotification.ERROR && (
                <button
                  type='button'
                  className='close'
                  data-dismiss='modal'
                  aria-label='Close'
                  onClick={() => {
                    dispatch(clearNotification());
                    if (
                      notification.type === ENotification.ERROR &&
                      history.location.pathname !== ERoutes.HOME
                    ) {
                      const exceptionName = notification.msg1.split('.')[1];
                      const isNoGoBack = noBackErrors.includes(
                        exceptionName as EErrorName,
                      );
                      return isNoGoBack ? null : history.goBack();
                    }
                  }}
                >
                  <span aria-hidden='true'>&times;</span>
                </button>
              )}
            </div>
            <div className='modal-body'>
              <p className='w-100 text-center'>
                <FormattedMessage
                  id={notification.msg1}
                  values={
                    notification.value1
                      ? { value: notification.value1 }
                      : undefined
                  }
                />
              </p>
              {!!notification.msg2 && (
                <p className='text-danger info-txt ml-4'>
                  <FormattedMessage
                    id={notification.msg2}
                    values={
                      notification.value2
                        ? { value: notification.value2 }
                        : undefined
                    }
                  />
                </p>
              )}
            </div>
            {notification.type === ENotification.WARNING && (
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn-lili small secondary'
                  data-dismiss='modal'
                  onClick={() => dispatch(clearNotification())}
                >
                  <FormattedMessage id='common.no' />
                </button>
                <button
                  type='button'
                  className='btn-lili small danger'
                  onClick={(e: any) => {
                    e.preventDefault();
                    if (notification.dispatch) {
                      dispatch(
                        notification.dispatch.func(
                          ...notification.dispatch.param,
                        ),
                      );
                    }
                    if (notification.func) {
                      notification.func.func(
                        ...(notification.func.param
                          ? notification.func.param
                          : [])
                      );
                    }
                    if (notification.cb) {
                      notification.cb.func(
                        notification.cb.param ? notification.cb.param : null,
                      );
                    }
                    dispatch(clearNotification());
                  }}
                >
                  <FormattedMessage id='common.yes' />
                </button>
              </div>
            )}
            {notification.type === ENotification.SUCCESS && (
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn-lili small'
                  onClick={(e: any) => {
                    e.preventDefault();
                    if (!!notification.dispatch) {
                      dispatch(
                        notification.dispatch.func(
                          ...notification.dispatch.param,
                        ),
                      );
                    }
                    dispatch(clearNotification());
                    if (!!notification.cb) {
                      return notification.cb.func(
                        notification.cb.param ? notification.cb.param : null,
                      );
                    }
                  }}
                >
                  <FormattedMessage id='common.ok' />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return <React.Fragment>{props.children}</React.Fragment>;
}
